<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="mb-0">Dokumentet</h3>
      <div v-if="documentStore.loading" class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div v-if="documentStore.error" class="alert alert-danger">
        {{ documentStore.error }}
      </div>

    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <input type="text" v-model="searchValue" class="form-control" placeholder="Search documents..." />
      </div>
    </div>

    <div v-if="!documentStore.loading && !documentStore.error && paginatedData.length === 0" class="alert alert-info">
      No documents found.
    </div>

    <table v-else class="table table-bordered">
      <thead>
        <tr>
          <th>Title</th>
          <th>Created Date</th>
          <th>Language</th>
          <th>Document File</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="doc in paginatedData" :key="doc.Id">
          <td>{{ doc.Title }}</td>
          <td>{{ doc.CreatedDate}}</td>
          <td>{{ doc.Language }}</td>
          <td>
            <a v-if="doc.DocumentFileUrl" :href="doc.DocumentFileUrl" target="_blank">View File</a>
            <span v-else>No File</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-center mt-3">
      <ul class="pagination">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Previous</button>
        </li>
        <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">Next</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//import { useDocumentStore } from '@/stores/documentStore';

import { useDocumentStore } from '@/store/DocumentStore/documentStore';
import { useRoute } from 'vue-router';
import { onMounted, computed, ref } from 'vue';

export default {
  setup()
  {
    const documentStore = useDocumentStore();
    const route = useRoute();
    const searchValue = ref('');
    const currentPage = ref(1);
    const itemsPerPage = 10;

    const fetchDocs = async () =>
    {
      const docData = {
        prokuroriaId: route.query.prokuroriaId ? parseInt(route.query.prokuroriaId) : null,
        documentTypeId: route.query.documentTypeId ? parseInt(route.query.documentTypeId) : null,
      };
      await documentStore.getDocumentet(docData);
    };

    onMounted(fetchDocs);

    const filteredData = computed(() =>
    {
      if (!documentStore.documentet) return [];
      const searchTerm = searchValue.value.toLowerCase();
      return documentStore.documentet.filter((doc) =>
        doc.Title?.toLowerCase().includes(searchTerm) ||
        doc.Language?.toLowerCase().includes(searchTerm) ||
        doc.CreatedDate?.toLowerCase().includes(searchTerm)
      );
    });

    const paginatedData = computed(() =>
    {
      const start = (currentPage.value - 1) * itemsPerPage;
      return filteredData.value.slice(start, start + itemsPerPage);
    });

    const totalPages = computed(() => Math.ceil(filteredData.value.length / itemsPerPage));

    const changePage = (page) =>
    {
      if (page >= 1 && page <= totalPages.value)
      {
        currentPage.value = page;
      }
    };

  


    return {
      documentStore,
      searchValue,
      currentPage,
      totalPages,
      paginatedData,
      changePage,
    

    };
  },
};
</script>

<style>
/* Same styles as provided */
.dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

.filter-chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  background-color: #e9ecef;
  border-radius: 16px;
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
  font-size: 0.9em;
}

.remove-chip {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 1.2em;
  line-height: 1;
  margin-left: 4px;
  padding: 0;
  cursor: pointer;
}

.remove-chip:hover {
  color: #bb2d3b;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.me-2 {
  margin-right: 0.5rem;
}

th {
  position: relative;
  vertical-align: middle;
}

.filter-icon {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  vertical-align: middle;
}

.filter-icon i {
  color: #000;
  font-size: 1rem;
}

.filter-icon:hover i {
  color: #ccc;
}

.dropdown-menu {
  margin-top: 5px;
}

.pagination {
  margin-top: 20px;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.pagination-container {
  gap: 15px;
}

.pagination-wrapper {
  flex: 1;
  max-width: 40%;
}

.pagination {
  margin-bottom: 0;
  flex-wrap: nowrap;
}

.entries-info {
  flex: 1;
  text-align: center;
  white-space: nowrap;
  padding: 0 10px;
}

.items-per-page {
  flex: 1;
  max-width: 150px;
}

.page-link {
  padding: 0.375rem 0.75rem;
}

.form-select {
  height: calc(1.5em + 0.75rem + 2px);
}
</style>